import { CtaStyle, CtaType } from '../cta';
import { PageTypes } from '../platform';

export default function getCtaType(pageType: PageTypes, ctaStyle: CtaStyle, partner?: string): CtaType {
  let ctaType: CtaType;

  if ((pageType === 'srp' || pageType === 'srp_legacy') && ctaStyle === 'banner') {
    ctaType = 'srp_header_widget';
  } else if ((pageType === 'srp' || pageType === 'srp_legacy') && ctaStyle !== 'banner' && ctaStyle !== 'sidebar') {
    ctaType = 'srp_widget';
  } else if (pageType === 'vdp' && partner?.includes('CFMOTO')) {
    ctaType = 'cfmoto_model_page_widget';
  } else if (pageType === 'summary' && ctaStyle === 'cfmoto-summary') {
    ctaType = 'cfmoto_build_summary_widget';
  } else if ((pageType === 'vdp' || pageType === 'vdp_legacy') && ctaStyle !== 'sidebar') {
    ctaType = 'vdp_widget';
  } else if (pageType === 'homepage' && ctaStyle === 'banner') {
    ctaType = 'homepage_footer_widget';
  } else if (ctaStyle === 'sidebar') {
    ctaType = 'sidebar_widget';
  } else throw new Error(`PageType and CTA style combination not expected.`);
  return ctaType;
}
